<template>
  <div class="sds-hmis-label d-flex">
    <div v-for="haz of product.hazards" :key="haz.id">
      <img
        :src="`/img/ems/ghs-${haz.id}.svg`"
        :alt="haz.description"
        :title="haz.name"
        class="ms-1"
        width="40"
        height="40"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "SdsGhsLabel",
  props: {
    product: {
      type: Object
    }
  }
};
</script>
